/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Firstreminderleadtime3Inputs */

const en__field_firstreminderleadtime3 = /** @type {(inputs: _Field_Firstreminderleadtime3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First Reminder x Days ahead`)
};

const de__field_firstreminderleadtime3 = /** @type {(inputs: _Field_Firstreminderleadtime3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erste Erinnerung x Tage vorher`)
};

/**
* | output |
* | --- |
* | "First Reminder x Days ahead" |
*
* @param {_Field_Firstreminderleadtime3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_firstreminderleadtime3 = /** @type {((inputs?: _Field_Firstreminderleadtime3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Firstreminderleadtime3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_firstreminderleadtime3(inputs)
	return de__field_firstreminderleadtime3(inputs)
});
export { _field_firstreminderleadtime3 as "_field_firstReminderLeadTime" }